// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-downloads-ec-track-box .wm-box {
  position: relative;
  margin: 10px;
  border-radius: 15px;
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  transition: all 500ms;
  height: 100%;
  max-height: 176px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
wm-downloads-ec-track-box .wm-box .color {
  position: absolute;
  border-radius: 15px;
  clip-path: polygon(100% 0, 85% 0, 100% 25%);
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  height: 100%;
  width: 100%;
  z-index: 1;
  background-color: #ca1551;
}
wm-downloads-ec-track-box .wm-box .wm-box-icon {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin: 0;
  height: 48px;
  width: 48px;
  margin: 10px;
  border-width: 1px;
  z-index: 2;
}
wm-downloads-ec-track-box .wm-box .wm-box-icon svg {
  height: 100%;
}
wm-downloads-ec-track-box .wm-box wm-img {
  height: 100%;
}
wm-downloads-ec-track-box .wm-box wm-img img {
  position: absolute;
  border-radius: 15px;
  object-fit: cover;
  align-self: stretch;
  height: 100%;
  width: 100%;
  filter: brightness(75%);
}
wm-downloads-ec-track-box .wm-box .wm-box-title {
  font-size: 26px;
  font-family: var(--wm-font-family-content, inherit);
  font-style: normal;
  font-weight: 700;
  color: white;
  position: absolute;
  bottom: 0;
  padding: 6%;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
  white-space: break-spaces;
}
wm-downloads-ec-track-box ion-button {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0;
  left: 0;
  margin: 10px;
  --padding-start: 0.5em;
  --padding-end: 0.5em;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/box/downloads-ec-track-box /downloads-ec-track-box.component.scss","webpack://./src/app/shared/wm-core/projects/wm-core/src/box/downloads-ec-track-box%20/downloads-ec-track-box.component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;ACDJ;ADEI;EACE,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,8CAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;ACAN;ADEI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEA,iBAAA;EAIA,UAAA;ACJN;ADCM;EACE,YAAA;ACCR;ADGI;EACE,YAAA;ACDN;ADEM;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;ACAR;ADII;EACE,eAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;ACHN;ADOE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;ACLJ","sourcesContent":["wm-downloads-ec-track-box {\n  .wm-box {\n    position: relative;\n    margin: 10px;\n    border-radius: 15px;\n    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n    transition: all 500ms;\n    height: 100%;\n    max-height: 176px;\n    cursor: pointer;\n\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    .color {\n      position: absolute;\n      border-radius: 15px;\n      clip-path: polygon(100% 0, 85% 0, 100% 25%);\n      box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n      height: 100%;\n      width: 100%;\n      z-index: 1;\n      background-color: #ca1551;\n    }\n    .wm-box-icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      margin: 0;\n      height: 48px;\n      width: 48px;\n      margin: 10px;\n\n      border-width: 1px;\n      svg {\n        height: 100%;\n      }\n      z-index: 2;\n    }\n    wm-img {\n      height: 100%;\n      img {\n        position: absolute;\n        border-radius: 15px;\n        object-fit: cover;\n        align-self: stretch;\n        height: 100%;\n        width: 100%;\n        filter: brightness(75%);\n      }\n    }\n\n    .wm-box-title {\n      font-size: 26px;\n      font-family: var(--wm-font-family-content, inherit);\n      font-style: normal;\n      font-weight: 700;\n      color: white;\n      position: absolute;\n      bottom: 0;\n      padding: 6%;\n\n      line-height: 31px;\n      letter-spacing: 0em;\n      text-align: left;\n      white-space: break-spaces;\n    }\n  }\n\n  ion-button {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    top: 0;\n    left: 0;\n    margin: 10px;\n    --padding-start: 0.5em;\n    --padding-end: 0.5em;\n  }\n}\n","wm-downloads-ec-track-box .wm-box {\n  position: relative;\n  margin: 10px;\n  border-radius: 15px;\n  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n  transition: all 500ms;\n  height: 100%;\n  max-height: 176px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n  align-items: stretch;\n}\nwm-downloads-ec-track-box .wm-box .color {\n  position: absolute;\n  border-radius: 15px;\n  clip-path: polygon(100% 0, 85% 0, 100% 25%);\n  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  background-color: #ca1551;\n}\nwm-downloads-ec-track-box .wm-box .wm-box-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  margin: 0;\n  height: 48px;\n  width: 48px;\n  margin: 10px;\n  border-width: 1px;\n  z-index: 2;\n}\nwm-downloads-ec-track-box .wm-box .wm-box-icon svg {\n  height: 100%;\n}\nwm-downloads-ec-track-box .wm-box wm-img {\n  height: 100%;\n}\nwm-downloads-ec-track-box .wm-box wm-img img {\n  position: absolute;\n  border-radius: 15px;\n  object-fit: cover;\n  align-self: stretch;\n  height: 100%;\n  width: 100%;\n  filter: brightness(75%);\n}\nwm-downloads-ec-track-box .wm-box .wm-box-title {\n  font-size: 26px;\n  font-family: var(--wm-font-family-content, inherit);\n  font-style: normal;\n  font-weight: 700;\n  color: white;\n  position: absolute;\n  bottom: 0;\n  padding: 6%;\n  line-height: 31px;\n  letter-spacing: 0em;\n  text-align: left;\n  white-space: break-spaces;\n}\nwm-downloads-ec-track-box ion-button {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  top: 0;\n  left: 0;\n  margin: 10px;\n  --padding-start: 0.5em;\n  --padding-end: 0.5em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
